import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import Slider from "react-slick";
//import cell31 from "../../../assets/images/home/cell-3/1.svg";
//import cell32 from "../../../assets/images/home/cell-3/2.png";

let thisComponent;

class Equipment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: null
    };
  }

  componentWillMount() {
    thisComponent = this;
  }

  onVisibilityChange(isVisible) {
    if (isVisible) {
      // Solamente cambia visibilidad a TRUE
      thisComponent.setState({ isVisible });
    }
  }

  render() {
	const { id } = this.props;
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      swipeToSlide: true,
      // rows: 0,
      slidesToShow: 4,
	  slidesToScroll: 1,
	  responsive: [
		{
		  breakpoint: 768,
		  settings: {
			slidesToShow: 2
		  }
		},
		{
		  breakpoint: 480,
		  settings: {
			slidesToShow: 1
		  }
		}
	  ]
    };

    return (
      <VisibilitySensor onChange={this.onVisibilityChange}>
        <section
          id={id}
          className={`equipment ${
            this.state.isVisible ? "-visible" : "-hidden"
          }`}
        >
          <div className="equipment__wrapper container">
            <h2 className="subtitle">Equipamiento</h2>
            <div className="equipment__title-wrapper">
              <h3 className="title">
                Contamos con tecnología de última generación
              </h3>
              <small className="small">
                Equipos certificados bajo
                <br /> <strong>Normas IRAM ISO 9001</strong>
              </small>
            </div>
            <Slider className="equipment__carousel" {...settings}>
              <div className="equipment__item">
                <h4 className="title">Mindray<br/> BS-380</h4>
                <p className="text">Analizador químico clínico de pie, autónomo y de acceso aleatorio que ofrece 300 tests por hora de forma constante.</p>
              </div>
              <div className="equipment__item">
                <h4 className="title">Mindray<br/> BC-5300</h4>
                <p className="text">Sistema de sobremesa de vanguardia que proporciona resultados de hematología fiables y precisos.</p>
              </div>
              <div className="equipment__item">
                <h4 className="title">Snibe<br/> Maglumi 800</h4>
                <p className="text">Sistema de Inmunoensayo por Quimioluminiscencia (CLIA) - Tecnología innovadora con reactivos integrados.</p>
              </div>
              <div className="equipment__item">
                <h4 className="title">Cell<br/> MiniLite</h4>
                <p className="text">Sistema automatizado de electroforesis. Realiza, con total automatización, el proceso electroforético completo.</p>
              </div>
              <div className="equipment__item">
                <h4 className="title">Diestro<br/> 103A</h4>
                <p className="text">Equipo para medición de Electrolitos por el método Ion selectivo.</p>
              </div>
              <div className="equipment__item">
                <h4 className="title">Agappe<br/> Mispa i2</h4>
                <p className="text">Nefelómetro para la cuantificación de proteínas específicas de  importancia en áreas de riesgo.</p>
              </div>
              <div className="equipment__item">
                <h4 className="title">Crudo Caamaño<br/> BB</h4>
                <p className="text">Instrumento de alta precisión diseñado para lecturas rápidas en micro capilares de bilirrubina total, en suero o plasma</p>
              </div>
              <div className="equipment__item">
                <h4 className="title">Clot<br/> A1</h4>
                <p className="text">Sistema de detección óptica extremadamente sensible, incluso en plasmas lipémicos o con poca formación de fibrinas.</p>
              </div>
            </Slider>
          </div>
        </section>
      </VisibilitySensor>
    );
  }
}

export default Equipment;
